import { tailwindConfig } from "./tailwind.config"
import { tailwindConstants } from "./tailwind.constants"

export { tailwindConfig, tailwindConstants }
